import type React from 'react'
import { Box, Button, Card, Typography } from '@mui/material'
import { ArrowForward } from '@mui/icons-material'

interface Props {
  backgroundColor?: string
  iconBackgroundColor?: string
  icon?: JSX.Element
  text: string
  subtext: string
  buttonText: string
  handleButtonClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  dataTestId?: string
}
export const ActionCard = (props: Props): JSX.Element => {
  return <Card data-testid={props.dataTestId ?? 'actionCard'} sx={{
    width: '285px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '42px',
    padding: '20px 30px',
    backgroundColor: props.backgroundColor,
    borderRadius: '12px'
  }}
  >
    {props.icon != null && <Box sx={{
      width: '115px',
      height: '115px',
      backgroundColor: props.iconBackgroundColor,
      borderRadius: '12px',
      display: 'grid',
      placeContent: 'center'
    }}
    >
      {props.icon}
    </Box>}

    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px', alignItems: 'center' }}>
      <Typography variant='h4'>{props.text}</Typography>
      <Typography variant='h5' fontSize='18px' fontWeight='400' mb='20px'>{props.subtext}</Typography>
    </Box>

    <Button
      data-testid={props.dataTestId != null ? `${props.dataTestId}Button` : 'actionCardButton'}
      sx={[{
        backgroundColor: 'var(--white)',
        color: 'var(--grey-700)',
        marginTop: 'auto',
        padding: '12px 20px',
        textTransform: 'none',
        fontSize: '16px',
        fontWeight: '600'
      },
      {
        '&:hover': {
          backgroundColor: props.backgroundColor,
          color: 'var(--grey-700)'
        }
      }]}
      endIcon={<ArrowForward />}
      onClick={props.handleButtonClick}
    >{props.buttonText}</Button>
  </Card>
}
